<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('AddExcel')"
      :active.sync="addStokWholePopup"
      fullscreen
    >
      <b-row align-v="center">
       
        <b-col>
          {{ $t("SampleExcel") }}
          <a :href="'https://g4full.com/assets/SampleStockTemplate.xlsx'" download>{{
            $t("Download")
          }}</a>
          <br />
          <input type="file" @change="onChange" id="xmlListForExcel" />
        </b-col>

        <b-col style="text-align: start">
          <vs-button
            style="border-radius: 5px"
            variant="primary"
            v-on:click="wholeStockSave()"
          >
            {{ $t("Save") }}
          </vs-button>
        </b-col>
      </b-row>
      <b-row>
        <ag-grid-vue
          style="width: 100%; height: 400px; margin-top: 15px"
          class="ag-theme-alpine"
          :enableCellChangeFlash="true"
          :animateRows="true"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefsForExcel"
          :rowData="wholeActList"
          :localeText="localeText"
          :suppressCopyRowsToClipboard="true"
          :pagination="true"
        >
        </ag-grid-vue>
      </b-row>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";

export default {
  components: { AgGridVue, vSelect },
  data() {
    return {
      ROLE: this.$store.state.AppActiveUser.ROLE,
 
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      wholeActList: [],
      columnDefsForExcel: [],
    };
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
 
    onChange(e) {
      const vm = this;
      vm.wholeStockList = [];
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array", cellDates: true });
        let sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        vm.wholeStockList = XLSX.utils.sheet_to_json(worksheet);
        vm.setItems();
      };
      reader.readAsArrayBuffer(f);
    },
    setItems(items) {
      this.columnDefsForExcel = [];
      let list = this.wholeStockList[0];
      let columnList = Object.keys(list);
      columnList.forEach((val, index) => {
        if (val !== "Resim") {
          this.columnDefsForExcel.push({
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
          });
        }
      });
    },
  },
  watch: {
 
    payment(val) {
      return val;
    },
    data(val) {
      return val;
    },
    isSidebarActive(val) {
      return val;
    },
  },
 
  computed: {
 
    payment: {
      get() {
        return this.$store.state.customer.Payment;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    addStokWholePopup: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
